import type { CcoServiceModel } from '@core/services/cco/cco.service';
import type { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { buildImageUrl, ImageFolderEnum } from '@core/services/external-image.service';
import { of } from 'rxjs';

@Injectable()
export class CcoServiceImpl implements CcoServiceModel {
  //TODO move
  getCcoImages = (): Observable<string[]> =>
    of([
      buildImageUrl(ImageFolderEnum.Cco, 'julie.png'),
      buildImageUrl(ImageFolderEnum.Cco, 'charlotte.png'),
      buildImageUrl(ImageFolderEnum.Cco, 'mayline.png'),
      buildImageUrl(ImageFolderEnum.Cco, 'margaux-goy.png'),
      buildImageUrl(ImageFolderEnum.Cco, 'anais.png'),
    ]);
}
